import { useMemo } from 'react';
import { useHits } from 'react-instantsearch';
import { HitProps } from '@components/algolia/Hit';

export function useAlgoliaHits() {
  const { items, sendEvent } = useHits<HitProps>();

  const memoizedItems = useMemo(() => items, [items]);
  const memoizedSendEvent = useMemo(() => sendEvent, [sendEvent]);

  return { items: memoizedItems, sendEvent: memoizedSendEvent };
}
